/**
 * In-memory кеш медиа по Telegram file_id: после первой загрузки повторно открываем чат без запроса по тому же signed URL.
 * Signed URL меняется (t/sig), поэтому обычный HTTP-кеш браузера почти не помогает.
 */

const MAX_ENTRIES = 80;
/** @type {Map<string, string>} file_id → blob: URL */
const cache = new Map();
/** @type {Map<string, Promise<string>>} */
const pending = new Map();

function evictOldest() {
  const first = cache.keys().next().value;
  if (first === undefined) return;
  const u = cache.get(first);
  if (u) URL.revokeObjectURL(u);
  cache.delete(first);
}

export function getCachedChatMediaUrl(fileId) {
  if (!fileId || typeof fileId !== "string") return null;
  return cache.get(fileId) || null;
}

/**
 * Скачивает по signed URL, кладёт в кеш, возвращает blob: URL (или кидает ошибку).
 */
export function loadChatMediaIntoCache(fileId, signedUrl) {
  if (!fileId || typeof fileId !== "string" || !signedUrl) {
    return Promise.reject(new Error("fileId and signedUrl required"));
  }
  const hit = cache.get(fileId);
  if (hit) return Promise.resolve(hit);
  const existing = pending.get(fileId);
  if (existing) return existing;

  const p = (async () => {
    try {
      const res = await fetch(signedUrl, { credentials: "omit" });
      if (!res.ok) throw new Error(String(res.status));
      const blob = await res.blob();
      while (cache.size >= MAX_ENTRIES) evictOldest();
      const objectUrl = URL.createObjectURL(blob);
      cache.set(fileId, objectUrl);
      return objectUrl;
    } finally {
      pending.delete(fileId);
    }
  })();

  pending.set(fileId, p);
  return p;
}
